import React from "react";
import classNames from "classnames";
import {KeyboardArrowRight} from "../../../icons/keyboard-arrow/keyboard-arrow-right";
import {KeyboardArrowLeft} from "../../../icons/keyboard-arrow/keyboard-arrow-left";
import {observer} from "mobx-react";
import styles from "./shot-map-shot-selector.module.scss";
import {GAME_SHOT_CHARTS} from "../../../../widgets/game-shot-chart-widget/game-shot-charts.widget.consts";

export const ShotMapShotSelectorBackward = observer(({controller, onClick, shouldDisableArrows}) => {
  const {device: {isRtl}} = controller;

  const prevProps = {
    className: classNames(styles.arrow, {[styles.disable_arrow]: shouldDisableArrows}),
    onClick: () => onClick(GAME_SHOT_CHARTS.DIRECTIONS.prev)
  }

  return isRtl ? <KeyboardArrowRight {...prevProps}/> : <KeyboardArrowLeft {...prevProps}/>
});